"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const debounceDurationMs = 200;
/** A NetworkStatusListener that listens for online/offline events in the browser. */
class BrowserNetworkStatusListener {
    constructor() {
        this.listeners = [];
        this.debounceTimer = null;
        if (typeof window === 'undefined') {
            throw new Error('BrowserNetworkStatusListener can only be used in a browser environment');
        }
        // guard against navigator API not being available (oder browsers)
        // noinspection SuspiciousTypeOfGuard
        this._isOffline = typeof navigator.onLine === 'boolean' ? !navigator.onLine : false;
        window.addEventListener('offline', () => this.notifyListeners(true));
        window.addEventListener('online', () => this.notifyListeners(false));
    }
    isOffline() {
        return this._isOffline;
    }
    onNetworkStatusChange(callback) {
        this.listeners.push(callback);
    }
    removeNetworkStatusChange(callback) {
        const index = this.listeners.indexOf(callback);
        if (index !== -1) {
            this.listeners.splice(index, 1);
        }
    }
    notifyListeners(isOffline) {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = setTimeout(() => {
            this._isOffline = isOffline;
            [...this.listeners].forEach((listener) => listener(isOffline));
        }, debounceDurationMs);
    }
}
exports.default = BrowserNetworkStatusListener;
//# sourceMappingURL=browser-network-status-listener.js.map